import { DateUtil } from "./date.util"

export const FilterModes = {
    CURRENT_DAY: "CURRENT_DAY",
    CURRENT_MONTH: "CURRENT_MONTH",
    CURRENT_YEAR: "CURRENT_YEAR"
}

export function getTransactionStartDate() {
    /* if (process.env.REACT_APP_TRANSACTION_FILTER_MODE === FilterModes.CURRENT_DAY) {
        return new Date().setHours(0, 0, 0)
    }
    if (process.env.REACT_APP_TRANSACTION_FILTER_MODE === FilterModes.CURRENT_MONTH) {
        return DateUtil.firstDayOfCurrentMonth.setHours(0, 0, 0)
    }
    if (process.env.REACT_APP_TRANSACTION_FILTER_MODE === FilterModes.CURRENT_YEAR) {
        return DateUtil.firstDayOfYear.setHours(0, 0, 0)
    }

    return DateUtil.firstDayOfCurrentMonth.setHours(0, 0, 0) */
    return new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(0, 0, 0)
}

export function getVendingStartDate() {
    /* if (process.env.REACT_APP_VENDING_FILTER_MODE === FilterModes.CURRENT_DAY) {
        return new Date().setHours(0, 0, 0)
    }
    if (process.env.REACT_APP_VENDING_FILTER_MODE === FilterModes.CURRENT_MONTH) {
        return DateUtil.firstDayOfCurrentMonth.setHours(0, 0, 0)
    }
    if (process.env.REACT_APP_VENDING_FILTER_MODE === FilterModes.CURRENT_YEAR) {
        return DateUtil.firstDayOfYear.setHours(0, 0, 0)
    }

    return DateUtil.firstDayOfYear.setHours(0, 0, 0)
 */
    return new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(0, 0, 0)
}

export function getCurrentEndDate() {
    //return new Date().setHours(23, 59, 59)
    return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).setHours(23, 59, 59)
}
